// extracted by mini-css-extract-plugin
export default {"table":"B2H2_","header":"Byfy7","parameters":"Jrjwf","cell":"_7vtTA","parameterName":"bp09F","row":"pMiGx"};